import sectionFaqGridCss from '../css-snippets/section-faq-grid-02';

const html = `
<style>${sectionFaqGridCss}</style>
<div
  data-container="faq-grid-container-fluid-unique-id"
  data-id="unique-id"
  data-attribute="faq-grid-container-fluid"
  data-top-padding="true"
  data-bottom-padding="true"
  class="faq-grid-container-fluid"
  data-container-full-width="false"
>
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <div
      data-attribute="title-faq-grid"
      class="title-faq-grid"
      >
      <h2 style="text-align: center">
        <strong>Frequently Asked Questions</strong>
      </h2>
    </div>
    <div
      data-attribute="list-item"
      class="list-item"
    >
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What is Airmoto?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Airmoto is a portable tire inflator that allows you to inflate your
            tires easily and quickly.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What does Airmoto work with?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Works with cars, trucks, SUVs, motorcycles, bicycles, e-bikes,
            trailers, small RVs, ATVs, golf carts, lawn mowers, and more.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What is the warranty period?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Airmoto comes with a 1-year warranty covering manufacturing defects.
            Extended warranties are available.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Is it safe and easy to use?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Yes, Airmoto is designed with safety in mind and features like auto
            shut-off to prevent over-inflation.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What adapters are included?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Airmoto comes with a variety of adapters including a Schrader valve,
            Presta valve, needle adapter, and general adapter.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How long does it take to inflate tires?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Inflates a car tire in under 6 minutes, a truck tire in under 8
            minutes, a motorcycle tire in under 4 minutes, and a bicycle tire in
            under 3 minutes. Can vary by size of tire and the amount of air
            needed.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How long does it take to charge?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Airmoto charges quickly and can be fully charged in under 2 hours.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Where should I store the Airmoto?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Airmoto is compact and portable, making it easy to store in your
            glovebox, trunk, or garage.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How long is shipping times?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Orders typically ship within 1-2 business days and arrive within 3-5
            business days. Orders ship from Dallas, Texas.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What is the return policy?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Airmoto comes with a 90 Day Money Back Guarantee(excl. S&H). If
            you're not satisfied, easily return it for a refund as outlined in
            our return policy. Simple and easy.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

`;
export default html;
